import { SHARED_DOCUMENTS } from 'global/SharedDocumentFields';
import { INSTALLER_ENTRIES, TENANT_ID } from 'global/constants';
import { always, handleFieldRendering } from 'global/renderingValidationConstants';

export const NE_DOCUMENTS_FIELDS = {
  [INSTALLER_ENTRIES.MAIN_ENERGY_ONLY]: {
    [TENANT_ID.AVA]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.EDI]: [{ ...SHARED_DOCUMENTS[13] }, { ...SHARED_DOCUMENTS[17] }],
    [TENANT_ID.SHNG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.BAG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[17] },
      { ...SHARED_DOCUMENTS[18] },
      { ...SHARED_DOCUMENTS[30], isOptional: always },
      { ...SHARED_DOCUMENTS[32], isOptional: always },
    ],
    [TENANT_ID.LVN]: [{ ...SHARED_DOCUMENTS[13] }, { ...SHARED_DOCUMENTS[17] }],
    [TENANT_ID.MTN]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[17] },
    ],
  },
  [INSTALLER_ENTRIES.MAIN_GAS_ONLY]: {
    [TENANT_ID.AVA]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.EDI]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.SHNG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.BAG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
      { ...SHARED_DOCUMENTS[18] },
      { ...SHARED_DOCUMENTS[31], isOptional: always },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
  },
  [INSTALLER_ENTRIES.GUEST_ONLY]: {
    [TENANT_ID.AVA]: [],
    [TENANT_ID.EDI]: [],
    [TENANT_ID.SHNG]: [],
    [TENANT_ID.BAG]: [],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [],
  },
  [INSTALLER_ENTRIES.MAIN_BOTH]: {
    [TENANT_ID.AVA]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.EDI]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[16] },

      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.SHNG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.BAG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
      { ...SHARED_DOCUMENTS[18] },
      { ...SHARED_DOCUMENTS[30], isOptional: always },
      { ...SHARED_DOCUMENTS[31], isOptional: always },
      { ...SHARED_DOCUMENTS[32], isOptional: always },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
  },
  [INSTALLER_ENTRIES.MAIN_ENERGY_GUEST_GAS]: {
    [TENANT_ID.AVA]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.EDI]: [{ ...SHARED_DOCUMENTS[13] }, { ...SHARED_DOCUMENTS[17] }],
    [TENANT_ID.SHNG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.BAG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[17] },
      { ...SHARED_DOCUMENTS[18] },
      { ...SHARED_DOCUMENTS[30], isOptional: always },
      { ...SHARED_DOCUMENTS[32], isOptional: always },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[17] },
    ],
  },
  [INSTALLER_ENTRIES.GUEST_ENERGY_MAIN_GAS]: {
    [TENANT_ID.AVA]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
      { ...SHARED_DOCUMENTS[18] },
    ],
    [TENANT_ID.EDI]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.SHNG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
    [TENANT_ID.BAG]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
      { ...SHARED_DOCUMENTS[18] },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      { ...SHARED_DOCUMENTS[13] },
      { ...SHARED_DOCUMENTS[14] },
      { ...SHARED_DOCUMENTS[15] },
      { ...SHARED_DOCUMENTS[16] },
      { ...SHARED_DOCUMENTS[17] },
    ],
  },
};

export const NE_EXPERTS_DOCUMENTS_FIELDS = {
  [INSTALLER_ENTRIES.MAIN_ENERGY_ONLY]: {
    [TENANT_ID.AVA]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
    ],
    [TENANT_ID.EDI]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
    ],
    [TENANT_ID.SHNG]: [
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
    ],
    [TENANT_ID.BAG]: [
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 47, 48, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 46, 47, 48, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([46, 47, 48], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
    ],
    [TENANT_ID.LVN]: [
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 47, 48, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 46, 47, 48, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([46, 47, 48], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
    ],
    [TENANT_ID.MTN]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
    ],
  },
  [INSTALLER_ENTRIES.MAIN_GAS_ONLY]: {
    [TENANT_ID.AVA]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      {
        ...SHARED_DOCUMENTS[28],
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.EDI]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      {
        ...SHARED_DOCUMENTS[28],
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.SHNG]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      {
        ...SHARED_DOCUMENTS[28],
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.BAG]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      {
        ...SHARED_DOCUMENTS[28],
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      {
        ...SHARED_DOCUMENTS[28],
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
  },
  [INSTALLER_ENTRIES.GUEST_ONLY]: {
    [TENANT_ID.AVA]: [{ ...SHARED_DOCUMENTS[79] }],
    [TENANT_ID.EDI]: [{ ...SHARED_DOCUMENTS[79] }],
    [TENANT_ID.SHNG]: [{ ...SHARED_DOCUMENTS[79] }],
    [TENANT_ID.BAG]: [{ ...SHARED_DOCUMENTS[79] }],
    [TENANT_ID.LVN]: [{ ...SHARED_DOCUMENTS[79] }],
    [TENANT_ID.MTN]: [{ ...SHARED_DOCUMENTS[79] }],
  },
  [INSTALLER_ENTRIES.MAIN_BOTH]: {
    [TENANT_ID.AVA]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.EDI]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.SHNG]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.BAG]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 47, 48, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 46, 47, 48, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([46, 47, 48], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
    ],
  },
  [INSTALLER_ENTRIES.MAIN_ENERGY_GUEST_GAS]: {
    [TENANT_ID.AVA]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.EDI]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.SHNG]: [
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.BAG]: [
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 46, 47, 48, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([46, 47, 48], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 47, 48, 49, 51, 53], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[25],
        whenShouldFieldRender: handleFieldRendering([53], []),
      },
      {
        ...SHARED_DOCUMENTS[27],
        whenShouldFieldRender: handleFieldRendering([43, 49, 51, 53], []),
      },
      {
        ...SHARED_DOCUMENTS[70],
        whenShouldFieldRender: handleFieldRendering([42, 43, 45, 49, 51, 52], []),
      },
      {
        ...SHARED_DOCUMENTS[71],
        whenShouldFieldRender: handleFieldRendering([45, 49], []),
      },
      {
        ...SHARED_DOCUMENTS[72],
        whenShouldFieldRender: handleFieldRendering([51, 52], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
  },
  [INSTALLER_ENTRIES.GUEST_ENERGY_MAIN_GAS]: {
    [TENANT_ID.AVA]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.EDI]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.SHNG]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.BAG]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
    [TENANT_ID.LVN]: [],
    [TENANT_ID.MTN]: [
      {
        ...SHARED_DOCUMENTS[23],
        whenShouldFieldRender: handleFieldRendering([], [40]),
      },
      {
        ...SHARED_DOCUMENTS[26],
        whenShouldFieldRender: handleFieldRendering([69], []),
      },
      { ...SHARED_DOCUMENTS[28] },
      {
        ...SHARED_DOCUMENTS[29],
        whenShouldFieldRender: handleFieldRendering([58, 61, 64, 66, 67, 68, 69], []),
      },
      {
        ...SHARED_DOCUMENTS[73],
        whenShouldFieldRender: handleFieldRendering([57, 58, 60, 61, 63, 64], []),
      },
      {
        ...SHARED_DOCUMENTS[74],
        whenShouldFieldRender: handleFieldRendering([60, 61], []),
      },
      {
        ...SHARED_DOCUMENTS[75],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[76],
        whenShouldFieldRender: handleFieldRendering([66, 67, 68], []),
      },
      {
        ...SHARED_DOCUMENTS[77],
        whenShouldFieldRender: handleFieldRendering([63, 64], []),
      },
      { ...SHARED_DOCUMENTS[79] },
    ],
  },
};
